import type { BonusAward, BonusData, BonusKpi } from "./use-staff-bonuses";
import { staffBonusReasonChoices } from "../../../../shared/staff-bonus-suggestions";
export type CertificateType=string;
export const certificateTypes:CertificateType[]=["star_month","star_week","recognition","promotion"];
export function certificateLabel(type:CertificateType,rtl=false){
 const labels:Record<string,string[]>={star_month:["★ Star of the month","★ نجم الشهر"],star_week:["★ Star of the week","★ نجم الأسبوع"],recognition:["👏 Recognition","👏 تقدير"],promotion:["▲ Promotion","▲ ترقية"]};
 return labels[type]?.[rtl?1:0]||type;
}
export function certificateTitle(type:CertificateType,rtl=false){
 const labels:Record<string,string[]>={star_month:["Star of the Month","نجم الشهر"],star_week:["Star of the Week","نجم الأسبوع"],recognition:["Certificate of Recognition","شهادة تقدير"],promotion:["Certificate of Promotion","شهادة ترقية"]};
 return labels[type]?.[rtl?1:0]||type;
}
export function achievementLabel(type:CertificateType,count:number,rtl=false){
 const labels:Record<string,string[]>={star_month:["★ Star of the Month","★ نجم الشهر"],star_week:["★ Star of the Week","★ نجم الأسبوع"],recognition:["✦ Customer praise","✦ إشادة العملاء"],promotion:["▲ Promotion","▲ ترقية"]};
 return `${labels[type]?.[rtl?1:0]||type} ×${count}`;
}
export function recognitionOnly(k:Pick<BonusKpi,"certificate"|"payType"|"amount"|"scoreAmounts"|"amountType">|null|undefined){
 return !!k?.certificate&&(k.payType==="fixed"?k.amountType!=="range"&&Number(k.amount)===0:k.scoreAmounts.every(v=>Number(v)===0));
}
export const recognitionText=(rtl:boolean)=>rtl?"تقدير فقط":"Recognition only";
export function awardCertificate(a:BonusAward,data?:BonusData):CertificateType|null{
 if(a.certificateSnapshot)return a.certificate||"snapshot";
 // Explicit null is historical evidence too. Only absent legacy fields use the KPI fallback.
 return a.certificate===undefined?(a.certificateEvidence?a.certificateEvidence.certificate:data?.kpis.find(k=>k.id===a.kpiId)?.certificate||null):a.certificate;
}
export function certificateReasons(k:BonusKpi|null,data:BonusData){
 if(k?.certificate==="promotion")return data.positions.map(p=>`Promoted to ${p.name}`);
 if(k?.certificate==="star_month")return staffBonusReasonChoices.star_month.reasons;
 if(k?.certificate==="star_week")return staffBonusReasonChoices.star_week.reasons;
 return null;
}
export function achievementAwards(data:BonusData,employeeId:string){
 return data.awards.filter(a=>a.employeeId===employeeId&&a.status!=="cancelled"&&awardCertificate(a,data)).sort((a,b)=>b.createdAt.localeCompare(a.createdAt));
}
export function achievementCounts(data:BonusData,employeeId:string){
 const awards=achievementAwards(data,employeeId);
 return Object.fromEntries(certificateTypes.map(type=>[type,awards.filter(a=>awardCertificate(a,data)===type).length])) as Record<CertificateType,number>;
}
